var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpCabinetProjectSaleEndIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.875 15C26.875 9.4025 26.875 6.6025 25.1363 4.86375C23.3975 3.125 20.5988 3.125 15 3.125C9.4025 3.125 6.6025 3.125 4.86376 4.86375C3.12501 6.6025 3.125 9.40125 3.125 15C3.125 20.5975 3.12501 23.3975 4.86376 25.1362C6.6025 26.875 9.40125 26.875 15 26.875C20.5975 26.875 23.3975 26.875 25.1363 25.1362C26.875 23.3975 26.875 20.5987 26.875 15Z",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9902 13.135C15.4875 13.135 15.9644 13.3325 16.3161 13.6842C16.6677 14.0358 16.8652 14.5127 16.8652 15.01C16.8652 15.5073 16.6677 15.9842 16.3161 16.3358C15.9644 16.6875 15.4875 16.885 14.9902 16.885C14.493 16.885 14.016 16.6875 13.6644 16.3358C13.3128 15.9842 13.1152 15.5073 13.1152 15.01C13.1152 14.5127 13.3128 14.0358 13.6644 13.6842C14.016 13.3325 14.493 13.135 14.9902 13.135ZM14.9902 13.135V8.75M11.2315 18.775L13.6677 16.34",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpCabinetProjectSaleEndIcon);
export default __webpack_public_path__ + "static/media/lp_cabinet_project_sale_end_icon.092a4103ac2da907bbaac5429e7a1f3c.svg";
export { ForwardRef as ReactComponent };